

import ltLabelDesigner from "./components/lt-label-designer/index.js"

var components = {
    ltLabelDesigner
}

export default {
    install: function (Vue) {
        if (this.installed) return;
        for (var i in components) {

            var component = components[i]
            Vue.component(component.name, component);
        }
    },

    ltMxgraph,

}